import KeyedItem from "../base/item";

export type DocumentLink = {
  originSource?: string;
  destinationSource: string;
  tenantId: string;
  originDocumentId?: string;
  destinationDocumentId: string;
  destinationWorkspaceId?: string;
  /** Display name of the workspace containing the destination document (enriched API). */
  destinationWorkspaceName?: string;
  originWorkspaceId?: string;
  /** Display name of the workspace containing the origin document (enriched API). */
  originWorkspaceName?: string;
  originHtmlIds?: string[];
  destinationHtmlIds: string[];
  originUniqueChunkText?: string;
  destinationUniqueChunkText?: string;
  originUniqueMatchText?: string;
  destinationUniqueMatchText?: string;
  isDestinationStatic?: boolean;
  extraMetadata?: Record<string, string>;
  isTemplate: boolean;
  name?: string;
  sourceName?: string;
  /** Server-resolved: workspace file name or legislation short name for the origin end. */
  originDocumentName?: string;
  /** Server-resolved: workspace file name or legislation short name for the destination end. */
  destinationDocumentName?: string;
  originVersion?: number;
  destinationVersion?: number;
  /** True when the origin link points to the active (current) revision of the workspace document. */
  originIsActiveRevision?: boolean;
  /** True when the destination link points to the active (current) revision of the workspace document. */
  destinationIsActiveRevision?: boolean;
} & KeyedItem;

export type ExtraMetadata = {
  ref_type?: RefType;
  origin_title?: string;
  destination_title?: string;
  origin_short_name?: string;
  origin_popular_title?: string;
  destination_short_name?: string;
  destination_popular_title?: string;
  origin_document_type_id?: string;
  destination_document_type_id?: string;
  origin_is_historical?: boolean;
  destination_is_historical?: boolean;
  header?: string;
  state_label?: string;
  /** Consolidation the reference was created from: pinned change law (static references). */
  destination_change_law?: string;
  /** Consolidation date pinned alongside `destination_change_law`. */
  destination_as_of?: string;
  /** `"true"` when a dynamic reference should open the latest consolidation of the destination. */
  destination_consolidated?: string;
};

export enum RefType {
  INTERNAL = "internal",
  TEXT_LEVEL_TO_TEXT_LEVEL = "text_level_to_text_level",
  TEXT_LEVEL_TO_DOCUMENT = "text_level_to_document",
  DOCUMENT_TO_DOCUMENT = "document_to_document",
  DOCUMENT_TO_TEXT_LEVEL = "document_to_text_level",
  CASE_HISTORY = "case_history",
}

export type PostTemplateRequestBody = {
  name?: string;
  destinationSource: string;
  destinationDocumentId: string;
  destinationHtmlIds: string[];
  destinationWorkspaceId?: string;
  destinationUniqueChunkText?: string;
  destinationUniqueMatchText?: string;
  /** When true, reference stays fixed; false = follow new law (Retsinformation). */
  isDestinationStatic?: boolean;
  /** Serialized JSON — the API binds this as a string, not an object. */
  extraMetadata?: string;
};
